module.exports = __webpack_public_path__ + "static/media/group-71.b8aee9d0.svg";